import React from 'react';
import { motion } from 'framer-motion';
import { Logo } from '../Logo';
import { ThemeToggle } from '../ThemeToggle';
import { DownloadIcon } from 'lucide-react';
import { cvHref, navItems, profile, socialLinks } from '../../data/profile';
import { INDICATOR_SPRING } from '../../utils/motion';
import { useActiveSection } from '../../hooks/useActiveSection';
const SECTION_IDS = navItems.map(item => item.id);

// Tracks the active section itself, so scrolling re-renders only the sidebar, not the whole page.
export function Sidebar() {
  const active = useActiveSection(SECTION_IDS);
  const goTo = (id: string) => {
    document.getElementById(id)?.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  };
  return <aside className="sticky top-0 hidden h-screen w-48 shrink-0 flex-col py-10 lg:flex" data-id="element-292" data-mp="2anqbq6pkwhb1">
      <div className="flex items-center gap-3" data-id="element-293" data-mp="384fb7tr237h9">
        <Logo className="h-10 w-10" data-id="element-294" data-mp="33cx8b05h2wtn" />
        <div data-id="element-295" data-mp="33bvw2scq04ac">
          <p className="text-sm font-semibold text-fg" data-id="element-296" data-mp="33c5f1vzclb6j">{profile.name}</p>
          <p className="text-xs text-fg-faint" data-id="element-297" data-mp="39ontwlizhvar">{profile.location}</p>
        </div>
        <ThemeToggle className="ml-auto" data-id="element-298" data-mp="3enr049apa7kb" />
      </div>

      <nav aria-label="Sections" className="mt-10" data-id="element-299" data-mp="3en8wgrlpkr2d">
        <ul className="space-y-0.5" data-id="element-300" data-mp="30x5i0mt2m1nh">
          {navItems.map(item => {
          const isActive = active === item.id;
          return <li key={item.id} data-id="element-301" data-mp="34wealocdjthg">
                <button type="button" onClick={() => goTo(item.id)} aria-current={isActive ? 'true' : undefined} className={`relative flex w-full items-center gap-3 rounded-lg px-3 py-2 text-left text-sm transition-colors duration-150 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ink/30 ${isActive ? 'text-ink' : 'text-fg-muted hover:text-fg'}`} data-id="element-302" data-mp="2qyfzqsx9if6p">
                  {isActive && <motion.span layoutId="nav-active" className="absolute inset-0 rounded-lg bg-ink-soft" transition={INDICATOR_SPRING} data-id="element-303" data-mp="k6yoh6o3osy5" />}
                  <span className="relative w-4 text-[11px] tabular-nums text-fg-faint" data-id="element-304" data-mp="1o7y7c6xnuu95">{item.index}</span>
                  <span className="relative font-medium" data-id="element-305" data-mp="1k638d937csyj">{item.label}</span>
                </button>
              </li>;
        })}
        </ul>
      </nav>

      <ul className="mt-8 space-y-2 px-3" data-id="element-306" data-mp="2buwol6tlu684">
        {socialLinks.map(link => <li key={link.label} data-id="element-307" data-mp="27uw16woj2kox">
            <a href={link.href} target="_blank" rel="noreferrer" className="text-xs text-fg-muted underline decoration-line underline-offset-4 transition-colors duration-150 hover:text-ink hover:decoration-ink" data-id="element-308" data-mp="27vxllrrfojjb">
              {link.label}
            </a>
          </li>)}
      </ul>

      <a href={cvHref} target={profile.cv ? '_blank' : undefined} rel="noreferrer" className="mt-8 inline-flex items-center justify-center gap-2 rounded-full border border-line bg-white px-5 py-2.5 text-sm font-medium text-fg transition-[border-color,transform] duration-150 ease-out hover:border-ink/40 active:scale-[0.97]" data-id="element-309" data-mp="2qrnp5jf0lnzb">
        <DownloadIcon className="h-4 w-4" aria-hidden data-id="element-310" data-mp="3c3cujti08kfs" />
        Download CV
      </a>

      <a href={`mailto:${profile.email}`} className="mt-2 inline-flex items-center justify-center rounded-full bg-ink px-5 py-2.5 text-sm font-medium text-white transition-[background-color,transform] duration-150 ease-out hover:bg-ink-deep active:scale-[0.97]" data-id="element-311" data-mp="3c19x4oeivp11">
        Let's talk
      </a>
    </aside>;
}